import { getApi } from "./general.service";

/**
 * Dashboard stats (backend: boost-api-v3 src/backoffice/stats/stats.module.ts):
 *   GET /admin/stats/overview
 *     → { users: { total, newLast30d, activeLast24h, activeLast7d, activeLast30d },
 *         premium: { activeSubscriptions, payingSubscribers, trialSubscriptions,
 *                    newLast30d, byPlan: { monthly, yearly, lifetime },
 *                    estimatedMonthlyRevenueEur },
 *         content: { decks, decksAvailable, cards, aiDraftsPending } }
 *   GET /admin/stats/games-daily?days=7  → { days: [{ date, count }] }
 *   GET /admin/stats/popular-decks?take=5 → { results: [{ _id, title, avatarUrl?, metric }] }
 *   GET /admin/stats/inbox → { bugs: { pending, latest }, feedback: { pending, latest },
 *                              wordsToReview: { pending, latest: { _id, character, pinyin } } }
 */

export const getStatsOverview = async () => {
  return getApi("/admin/stats/overview");
};

export const getGamesDaily = async (days = 7) => {
  return getApi(`/admin/stats/games-daily?days=${days}`);
};

export const getPopularDecks = async (take = 5) => {
  return getApi(`/admin/stats/popular-decks?take=${take}`);
};

export const getRecentGames = async (take = 6) => {
  return getApi(`/admin/stats/recent-games?take=${take}`);
};

export const getStatsInbox = async () => {
  return getApi("/admin/stats/inbox");
};
